const mapStateToProps = (state) => ({
  loginError: state.account.loginError,
  status: state.account.loginStatus,
  anchorEl: null
})

export default mapStateToProps
